export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/containers/index.ts